
const lang ={
    Title: '模板',
    CreateTemplate: '创建模板',
    New: '新建',
    SearchTemplate: '搜索模板',
    SearchEmpty: '暂无记录',
    Cancel: '取消',
    loading: '加载中...',
    error: '错误',
    netWorkError: '网络错误，请检查网络是否连接',
    All: '全部',
    More: '更多',
    Suggest: '建议',
    Suggestion: '在此处键入建议',
    SuggestContentRequired: '请输入建议内容',
    SuggestSubmitSuccess: '建议已提交成功',
    Submit: '提交',
    EditNow: '编辑',
    Recommended: '推荐模板',
    MostPopular: '热门',
    AccountError: '请先登录账号'
};

export default lang;